// src/Dashboard/pages/teacher/AttendanceTable/components/AttendanceLegend.jsx

import React from "react";

function Dot({ className }) {
  return <span className={`inline-block h-3 w-3 rounded ${className}`} />;
}

export default function AttendanceLegend() {
  return (
    <div className="flex flex-wrap items-center gap-2 text-xs font-bold text-slate-600 dark:text-slate-300">
      <span className="inline-flex items-center gap-2 rounded-full bg-slate-50 px-3 py-2 ring-1 ring-slate-200 dark:bg-slate-800/60 dark:ring-slate-700">
        <Dot className="bg-emerald-500" />
        Présent
      </span>

      <span className="inline-flex items-center gap-2 rounded-full bg-slate-50 px-3 py-2 ring-1 ring-slate-200 dark:bg-slate-800/60 dark:ring-slate-700">
        <Dot className="bg-rose-500" />
        Absent
      </span>

      <span className="inline-flex items-center gap-2 rounded-full bg-slate-50 px-3 py-2 ring-1 ring-slate-200 dark:bg-slate-800/60 dark:ring-slate-700">
        <Dot className="bg-slate-300 dark:bg-slate-700" />
        Non saisi
      </span>
    </div>
  );
}